import Link from "next/link";
import styles from "./index.module.scss";

export default function Menu() {
  return (
    <ul className={styles.Links}>
      <li>
        <Link href="/info/">Для покупателей</Link>
      </li>
      <li>
        <Link href="/services/">Услуги</Link>
      </li>
      <li>
        <Link href="/reviews/">Отзывы</Link>
      </li>
      <li>
        <Link href="/about/">О компании</Link>
      </li>
      <li>
        <Link href="/contacts/">Контакты</Link>
      </li>
    </ul>
  );
}
